function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M1 12.5C1 18.851 6.149 24 12.5 24S24 18.851 24 12.5 18.851 1 12.5 1 1 6.149 1 12.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.5 18.25a.25.25 0 100 .5.25.25 0 000-.5h0M10 10.002a3 3 0 015.887-.813 3.003 3.003 0 01-1.687 3.565 1.999 1.999 0 00-1.2 1.834V15"
}));

function SvgHelp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25
  }, props), _ref);
}

export default SvgHelp;